import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { reactQueryClient } from "./service";
import { QueryClientProvider } from "react-query";
import { BrowserRouter as Router } from "react-router-dom";
import { ApolloProvider } from "@apollo/client/react";
import { apolloClient } from "./apolloClient";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <ApolloProvider client={apolloClient}>
    <Router>
      <QueryClientProvider client={reactQueryClient}>
        <App />
      </QueryClientProvider>
    </Router>
  </ApolloProvider>
);

reportWebVitals();
